import React from 'react'
import {
  AnimatePresence,
  motion,
  useTransform,
  useViewportScroll,
} from 'framer-motion'

export default function LogoContainer({ children }) {
  const { scrollY } = useViewportScroll()
  const height = useTransform(scrollY, [0, 200], ['2rem', '1.5rem'])

  const isHome =
    typeof window !== `undefined` && window.location.pathname === '/'

  if (isHome) {
    return (
      <AnimatePresence exitBeforeEnter initial={false}>
        <motion.div
          initial={{ height: '2rem' }}
          animate={{ height: '1.5rem' }}
          style={{ height }}
          className="hidden md:block"
        >
          {children}
        </motion.div>
      </AnimatePresence>
    )
  }

  return <div className="hidden h-6 md:block">{children}</div>
}
